import React from 'react';
import { toast } from 'sonner';

import { ButtonBase } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';

import ActionModal from 'components/ActionModal/ActionModal';
import { useLoadingIndicatorContext } from 'components/LoadingIndicator/LoadingIndicatorProvider';

import { resumeCampaign } from 'utils/api';
import { showAPIErrorAlert } from 'utils/lib';

const useStyles = makeStyles((theme) => ({
  cancelButton: {
    backgroundColor: `${theme.palette.grayScale6.main} !important`,
  },
}));

const CampaignResumeAction = ({
  campaign,
  mutateCampaign,
  children,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const { showLoadingIndicatorModal, hideLoadingIndicatorModal } = useLoadingIndicatorContext();
  const [showConfirmation, setShowConfirmation] = React.useState(false);

  const onResumeCampaign = async () => {
    showLoadingIndicatorModal();

    try {
      await resumeCampaign(campaign._id);
      await mutateCampaign();

      toast.success('Campaign resumed. Review the send dates for the remaining marketing touches!');
    } catch (err) {
      console.error(err);
      showAPIErrorAlert(err);
    } finally {
      setShowConfirmation(false);
      hideLoadingIndicatorModal();
    }
  };

  return (
    <>
      {showConfirmation && (
        <ActionModal
          backgroundColor={theme.palette.offWhite.main}
          textColor={theme.palette.darkGray.main}
          icon={<PlayCircleOutlineIcon />}
          onClose={() => setShowConfirmation(false)}
          title="Resume Campaign?"
          message="Marketing touches will resume and billing will restart where applicable."
          buttons={[
            <ButtonBase onClick={() => setShowConfirmation(false)} className={classes.cancelButton}>
              Cancel
            </ButtonBase>,
            <ButtonBase onClick={onResumeCampaign}>
              Resume Campaign
            </ButtonBase>,
          ]}
        />
      )}

      {React.cloneElement(React.Children.only(children), {
        onClick: () => setShowConfirmation(true),
      })}
    </>
  );
};

export default CampaignResumeAction;
